module.exports = __webpack_public_path__ + "img/cardface.394b3cd9.png";